import { CombinedDocumentsMap, GroupLayoutDocumentsMap } from 'models';
import { isGroupLayoutDocument } from './entityType';
import { filterCombinedDocuments } from './filterCombinedDocuments';

export const filterGroupLayouts = (documents: CombinedDocumentsMap): GroupLayoutDocumentsMap => {
  return filterCombinedDocuments(documents, isGroupLayoutDocument) as GroupLayoutDocumentsMap;
};
